import React, { memo } from "react";
import { AnimatePresence } from "framer-motion";

export const VisualAreaBottom = memo(({ children }: { children: React.ReactNode }) => {
    return <AnimatePresence mode="wait">{children}</AnimatePresence>;
});

VisualAreaBottom.displayName = "VisualAreaBottom";
